export const MAX_DESCRIPTION_LENGTH = 250;
export const DESCRIPTION_WARNING_THRESHOLD = 0.8;

export const CHECKBOX_IDS = {
    DESCRIPTION: 'description',
    CTA: 'cta',
};
